import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const showToast = useCallback((type = 'success', message, duration = 4000) => {
        const id = Math.random().toString(36).substr(2, 9);
        setToasts((prevToasts) => [...prevToasts, { id, type, message, duration }]);
    }, []);

    const removeToast = useCallback((id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);

    const success = (message, duration) => showToast('success', message, duration);
    const error = (message, duration) => showToast('error', message, duration);
    const warning = (message, duration) => showToast('warning', message, duration);
    const info = (message, duration) => showToast('info', message, duration);

    return (
        <ToastContext.Provider value={{ showToast, removeToast, toasts, success, error, warning, info }}>
            {children}
        </ToastContext.Provider>
    );
};
